import { roundAmount } from './roundAmount'

export const displayAmountClean = (amount: string | number): string => {
  const rounded = roundAmount(amount)

  // Convert to string and handle trailing zeros
  let result = rounded.toString()

  // If it has a decimal point, remove trailing zeros
  if (result.includes('.')) {
    result = result.replace(/0+$/, '').replace(/\.$/, '')
  }

  return result
}
